/* eslint-disable import/no-named-as-default-member */
import {
  CheckIcon,
  Divider,
  Grid2,
  SimpleLoader,
  Typography,
} from "components";
import { useFetchQuery } from "hooks/useQueries";
import DashboardLayout from "layouts/DashboardLayout";
import { useParams } from "react-router-dom";
import { GET_RISK_PROFILE_RESPONSE_BY_ID } from "utils/apiRoutes";
import { QueryKeys } from "utils/queryKey";
import useDocumentTitle from "utils/useDocumentTitle";

const ViewQuestionnaire = () => {
  useDocumentTitle("View Questionnaire");

  const { questionnaireId } = useParams();

  const { data: answer, isFetching } = useFetchQuery({
    key: [QueryKeys.VIEW_QUESTIONNAIRE],
    route: GET_RISK_PROFILE_RESPONSE_BY_ID(questionnaireId),
  });

  return (
    <DashboardLayout title="Client Risk Profile">
      <Grid2 container spacing={1}>
        {isFetching ? (
          <SimpleLoader />
        ) : (
          <Grid2 size={12}>
            {answer?.data?.data?.map((dataItem: any, index: number) => (
              <Grid2 container spacing={1}>
                <Grid2 size={12}>
                  <Typography
                    fontSize={14}
                    fontWeight={600}
                    color="var(--grey-900)"
                  >
                    <span>{index + 1}. </span>
                    {dataItem.questionText}
                  </Typography>
                </Grid2>

                <Grid2 size={6}>
                  {dataItem?.options?.map((optionItem: any) => {
                    const isSelected = dataItem.option === optionItem.id;

                    return (
                      <Typography
                        key={optionItem.id}
                        fontSize={13}
                        fontWeight={500}
                        color="var(--grey-900)"
                        p="14px 8px"
                        display="flex"
                        alignItems="center"
                        gap={1}
                        borderRadius={1}
                        bgcolor={isSelected ? "var(--primary-50)" : undefined}
                      >
                        {isSelected && <CheckIcon />}
                        {optionItem?.option}
                      </Typography>
                    );
                  })}
                </Grid2>

                <Grid2 size={12} py={2}>
                  <Divider />
                </Grid2>
              </Grid2>
            ))}
          </Grid2>
        )}
      </Grid2>
    </DashboardLayout>
  );
};

export default ViewQuestionnaire;
